<template>
	<div class="viewImage">
		<span v-on:click="openModal">
			<img :src="srcImage" :alt="altImage" :class="classImage" :style="styleImage"/>
		</span>
		<div class="modal-image" v-if="showModal">
  			<span class="close-view" v-on:click="closeModal">&times;</span>
			<img :class="classimg" :src="srcImage" :alt="altImage">
			<p v-text="altImage"></p>
			<span class="text-white">
				{{sizeKB}} KB ({{format(info.size)}} bytes)
			</span>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['id', 'src', 'alt', 'width', 'height', 'classimg', 'styleimg'],

		data(){
			return {
				showModal: false,
				info: {
					size: 0,
					type: '',
				},
				styles: '',
			}
		},

		mounted(){
			var imageUrl = this.srcImage;
			var vm = this;

			var blob = null;
			var xhr = new XMLHttpRequest(); 
			xhr.open('GET', imageUrl, true); 
			xhr.responseType = 'blob';
			xhr.onload = function() 
			{
			    blob = xhr.response;
			    vm.info.size = blob.size || 0;
			    vm.info.type = blob.type || '';
			}
			xhr.send();
		},

		methods: {
			openModal(){
				this.showModal = true;
				$('html').css('overflow','hidden');
			},

			closeModal(){
				this.showModal = false;
				$('html').css('overflow','auto');
			},

			format(value){
				return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
			}
		},

		computed: {
		    idImage: function(){
				return this.id;
			},

			srcImage: function(){
				return this.src;
			},

			altImage: function(){
				return this.alt;
			},

			widthImage: function(){
				return this.width;
			},

			heightImage: function(){
				return this.height;
			},

			classImage: function(){
				return this.classimg;
			},

			styleImage: function(){
				return this.styleimg;	
			},

			sizeKB: function(){
				return this.format(((this.info.size || 1)/1000).toFixed(2));
			}
		},
	}
</script>
<style>
	.viewImage > span > img {
		cursor: pointer;
		transition: 0.3s;
	}

	.viewImage > span > img:hover {
		opacity: 0.7;
	}

	.modal-image {
		position: fixed;
		z-index: 99999;
		padding-top: 100px;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
		background-color: rgb(0,0,0);
		background-color: rgba(0,0,0,0.9);
	}

	.modal-image > img {
		margin: auto;
		display: block;
		height: 80%;
		max-width: 80%;
		max-height: 700px;
		object-fit: contain;
	}

	.modal-image > p {
	  margin: auto;
	  display: block;
	  text-align: center;
	  color: #ccc;
	  padding: 10px 0;
	}

	.modal-image > img, .modal-image > p {  
		-webkit-animation-name: zoom;
		-webkit-animation-duration: 0.6s;
		animation-name: zoom;
		animation-duration: 0.6s;
	}

	@-webkit-keyframes zoom {
		from {-webkit-transform:scale(0)} 
		to {-webkit-transform:scale(1)}
	}

	@keyframes zoom {
		from {transform:scale(0)} 
		to {transform:scale(1)}
	}

	.modal-image > .close-view {
		position: absolute;
		top: 15px;
		right: 35px;
		color: #f1f1f1;
		font-size: 40px;
		font-weight: bold;
		transition: 0.3s;
	}

	.modal-image > .close-view:hover,
	.modal-image > .close-view:focus {
		color: #bbb;
		text-decoration: none;
		cursor: pointer;
	}

	/*@media only screen and (max-width: 700px){
	  .modal-image > img {
	    height: 100%;
	  }
	}*/
</style>